export default __webpack_public_path__ + "static/media/DGFT.e600182d.png";